<span (click)="openConfirmClose()" class="btn-close btn-close-custom" [ngClass]="{'onMobile': !AppComponent.isDesktop}">
  <mat-icon>close</mat-icon>
</span>

<section class="cc-wrapper" mat-dialog-content >
  <div [class]="AppComponent.isDesktop ? 'desktop-container-bank' : 'mb-container-bank'">
    <form class="cc-form" [formGroup]="bankForm">
      <div class="col-md-12">
        <mat-form-field appearance="outline">
          <mat-label>Account Type</mat-label>
          <mat-select formControlName="bankAccountType" [(ngModel)]="fundingSource.bank_account_type" required>
            <mat-option *ngFor="let item of bankAccountTypes | keys" [value]="item.key">
              {{item.value[0] + item.value.slice(1).toLowerCase()}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      <div class="col-md-12">
        <mat-form-field appearance="outline">
          <mat-label>Name On Account</mat-label>
          <input formControlName="bank_name_on_card" required matInput [(ngModel)]="fundingSource.bank_name_on_card">
        </mat-form-field>
      </div>
  
      <div class="col-md-12">
        <mat-form-field appearance="outline">
          <mat-label>Account Number</mat-label>
          <input formControlName="bank_account_number" required matInput [(ngModel)]="fundingSource.bank_account_number" >
        </mat-form-field>
      </div>
  
      <div class="col-md-12">
        <mat-form-field appearance="outline">
          <mat-label>Routing Number (9 digits)</mat-label>
          <input formControlName="routing_number" required matInput [(ngModel)]="fundingSource.routing_number"  maxlength="9">         
        </mat-form-field>
  
      </div>
      <div class="col-md-12">
        <mat-form-field appearance="outline">
          <mat-label>Financial Institution (max 30 characters)</mat-label>
          <input formControlName="bank_bankname" matInput required [(ngModel)]="fundingSource.bank_bankname" maxlength="70">          
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field appearance="outline">
          <mat-label>Financial Institution State (2 letters)</mat-label>
          <input style="text-transform: uppercase;" formControlName="bank_bankstate" required matInput
            [(ngModel)]="fundingSource.bank_bankstate" mask="AA" (ngModelChange)="checkBankState($event)" type="text" maxlength="2">         
        </mat-form-field>
      </div>
    </form>
      <div style="margin-top: 10px;" *ngIf="isCheckFormValid">
        <app-validations-error-list [validationErrors]="validationErrors"></app-validations-error-list>
        <mat-error class="error-message" style="margin-left: 15px;" *ngIf="invalidRoutingNumnerMsg">
          ❋ {{invalidRoutingNumnerMsg}}
        </mat-error>
      </div>
  
    <div class="row" style="margin: 0 auto 40px;" mat-dialog-actions>
      <div class="col-md-12">
        <button (click)="submit()" class="btn btn-custom btn-continue btn-block btn-submit">Submit</button>
      </div>
    </div>
  </div>
</section>